import { Collection } from 'modules/core/lib/mobx-rest'

import legalGenders from 'modules/settings/store/collections/legalGenders'
import Gender from 'modules/settings/store/models/Gender'

class Genders extends Collection<Gender> {
  get cacheKey(): string {
    return 'genders'
  }

  model() {
    return Gender
  }

  availablesIn(legalEntityId: number): Gender[] {
    const genderIds = legalGenders
      .filter({ legal_entity_id: legalEntityId })
      .map((legalGender) => legalGender.attributes.gender_id)

    return this.filter((gender) => genderIds.includes(gender.id))
  }
}

const singleton: Genders = new Genders()

export default singleton
